import { api_partners_featured_path, api_partners_subscriber_council_path } from '../../routes';
import request from './request';

export interface CommonPartnerFields {
  id: number;
  name: string;
  targetLink: string;
}
export interface FeaturedPartner extends CommonPartnerFields {
  buttonText?: string;
  description: string;
  logo: string;
}

export interface SubscriberCouncilPartner extends CommonPartnerFields {
  tagline: string;
}

export async function fetchFeaturedPartners(): Promise<FeaturedPartner[]> {
  const resp = await request('get', api_partners_featured_path());
  return resp;
}

export async function fetchSubscriberCouncilPartners(): Promise<SubscriberCouncilPartner[]> {
  const resp = await request('get', api_partners_subscriber_council_path());
  return resp;
}
